// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__nhj+h","spinner1":"style_spinner1__Udi5B","spinner2":"style_spinner2__n4sm+","spinner3":"style_spinner3__Bch8G"};